import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/activityTariffs`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/activityTariffs/${id}`, options)
        .then(response => {
            let tariffActivity = jsona.deserialize(response.data);
            delete tariffActivity.links;
            return tariffActivity;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/activityTariffs/${id}`, options)
        .then(response => {
            let tariffActivity = jsona.deserialize(response.data);
            delete tariffActivity.links;
            return tariffActivity;
        });
}

function add (tariffActivity) {
    const payload = jsona.serialize({
        stuff: tariffActivity,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/activityTariffs`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (tariffActivity) {
    const payload = jsona.serialize({
        stuff: tariffActivity,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/activityTariffs/${tariffActivity.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/activityTariffs/${id}`, options);
}

export default {
    list,
    get,
    show,
    add,
    update,
    destroy
};

